module.exports = __webpack_public_path__ + "media/images/athletes/4310-da94c7b1a0bb7fc91ba8d8f0582d26a4.png";